(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["configurators"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('configurator-slider')) {
  customElements.define('configurator-slider', class extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector('[data-config-scroll]');
      this.range = this.querySelector('.config-scrollbar');
      if (!this.grid || !this.range || this.updateScroll) return;
      this.updateScroll = () => {
        const max = this.grid.scrollWidth - this.grid.clientWidth;
        this.range.hidden = max <= 1;
        this.range.value = max > 0 ? this.grid.scrollLeft / max * 100 : 0;
        this.style.setProperty('--scroll-thumb', Math.max(36, this.grid.clientWidth / this.grid.scrollWidth * this.range.clientWidth) + 'px');
      };
      this.moveScroll = () => {
        this.grid.scrollLeft = (this.grid.scrollWidth - this.grid.clientWidth) * Number(this.range.value) / 100;
      };
      this.grid.addEventListener('scroll', this.updateScroll, { passive: true });
      this.range.addEventListener('input', this.moveScroll);
      this.resizeScroll = new ResizeObserver(this.updateScroll);
      this.resizeScroll.observe(this.grid);
      this.updateScroll();
    }
    disconnectedCallback() {
      this.grid?.removeEventListener('scroll', this.updateScroll);
      this.range?.removeEventListener('input', this.moveScroll);
      this.resizeScroll?.disconnect();
      this.updateScroll = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
